import { sellHttpApi } from "api";
import { IPackage } from "../List/api";

export interface IPackageItem {
  _id: string,
  name: string;
  description: string;
  code: string;
  canBeDonated: boolean;
  packageId: string;
  sellerId: string;
  status: string;
  images: string[];
  statusChangeHistory: any;
  grossSellerEarning?: number;
  price?: number;
  suggestedPrice?: number;
  repairs: {
    type: string;
    price: number;
    note?: string | null;
    completedAt?: string | null;
    startedAt?: string | null;
  }[],
  preListingTasks: {
    type: string;
    price: number;
    note?: string | null;
    completedAt?: string | null;
    startedAt?: string | null;
  }[],
  priceChangeHistory: {
    price: number;
    reason: string;
  }[],
  currentListingPrice: number;
  shopItemId: string;
  createdAt: string;
  minChangeablePrice: number;
  maxChangeablePrice: number;
  commissionTier: string;
  sellQuantity: number;
  bookedQuantity: number;
  soldQuantity: number;
  isPublished: boolean;
}

export interface IRequestPackageItemsResponse {
  packageItems: IPackageItem[] | null;
}

export async function requestGetPackageDetails(
  id: string
){
  const response = await sellHttpApi.makeAuthenticatedRequest<IPackage>(`/packages/${id}`, {
    method: "GET",
  });
  return response.json();
}

export async function requestGetPackageItems(
  id: string
) {
  const response = await sellHttpApi.makeAuthenticatedRequest<IRequestPackageItemsResponse>(`/package-items/?packageIds=${id}&sortBy=createdAt&limit=65535`, {
    method: "GET",
  });
  return response.json();
}

export async function requestAcceptPackageItemOffer(id: string, price: number) {
  const response = await sellHttpApi.makeAuthenticatedRequest<IPackageItem>(`/package-items/${id}`, {
    method: "PATCH",
    body: {
      status: 'OFFER_ACCEPTED',
      price
    }
  });
  return response.json();
}

export async function requestRejectPackageItemOffer(id: string) {
  const response = await sellHttpApi.makeAuthenticatedRequest<IPackageItem>(`/package-items/${id}`, {
    method: "PATCH",
    body: {
      status: 'OFFER_REJECTED'
    }
  });
  return response.json();
}

export async function requestCancelPackage (id: string) {
  const response = await sellHttpApi.makeAuthenticatedRequest<IPackage>(`/packages/${id}`, {
    method: "PATCH",
    body: {
      status: 'CANCELED'
    }
  });
  return response.json();
}

export async function requestSwitchPackageToPickup (id: string) {
  const response = await sellHttpApi.makeAuthenticatedRequest<IPackage>(`/packages/${id}`, {
    method: "PATCH",
    body: {
      shouldSchedulePickup: true
    }
  });
  return response.json();
}

export async function requestSwitchPackageToDropOff (id: string) {
  const response = await sellHttpApi.makeAuthenticatedRequest<IPackage>(`/packages/${id}`, {
    method: "PATCH",
    body: {
      shouldSchedulePickup: false
    }
  });
  return response.json();
}
